const getPassengerInsuranceChanges = (passengers, originalPassengers) => {
  const changes = [];
  if (!originalPassengers || !passengers || passengers.length !== originalPassengers.length) {
    return changes;
  }
  for (let index = 0; index < passengers.length; index += 1) {
    if ((passengers[index].insuranceCoverage || false)
      !== (originalPassengers[index].insuranceCoverage || false)) {
      changes.push({
        passenger: passengers[index],
        action: passengers[index].insuranceCoverage ? 'Selected' : 'Unselected',
      });
    }
  }
  return changes;
};

export default getPassengerInsuranceChanges;
